import { Fragment, ReactNode, Suspense } from 'react';

import { PageLoading } from './Loading';

type Props = {
  children: ReactNode;
  enabled?: boolean;
};

const AppRouteSuspense = ({
  children,
  enabled = process.env.NODE_ENV === 'production',
}: Props) => {
  if (!enabled) {
    return <Fragment>{children}</Fragment>;
  }

  return <Suspense fallback={<PageLoading />}>{children}</Suspense>;
};

export default AppRouteSuspense;
